import React, { useEffect } from "react";

const STRIPE_URLS = {
  1: "https://buy.stripe.com/14AaEXh03boiaoT6xods400",
  2: "https://buy.stripe.com/3cI14naBF9ga0OjbRIds401",
  3: "https://buy.stripe.com/cNi7sL1157828gL8Fwds402",
};

function getStripeUrl() {
  // Get the current pathname and search
  const { pathname, search } = window.location;

  // If not navigating from /product, just go to default
  if (!pathname.startsWith("/product")) {
    return STRIPE_URLS[1];
  }

  // Parse grade from search params
  const params = new URLSearchParams(search);
  const grade = params.get("grade");

  // Redirect based on grade
  if (grade === "1") return STRIPE_URLS[1];
  if (grade === "2") return STRIPE_URLS[2];
  if (grade === "3") return STRIPE_URLS[3];

  // Default fallback
  return STRIPE_URLS[1];
}

const Checkout: React.FC = () => {
  const stripeUrl = getStripeUrl();

  useEffect(() => {
    // Redirect as soon as the page loads
    window.location.href = stripeUrl;
  }, [stripeUrl]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="w-64 p-8 bg-white rounded-2xl shadow-md flex flex-col items-center gap-4">
        <svg
          className="animate-spin h-8 w-8 text-green-600 mb-4"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v8H4z"
          ></path>
        </svg>
        <h1 className="text-2xl font-bold mb-2 text-center">
          Redirecting to Secure Checkout...
        </h1>
        <p className="text-gray-600 text-center">
          Please wait while we take you to Stripe.
        </p>
        <a
          href={stripeUrl}
          className="text-green-700 hover:underline text-center mt-2 text-sm font-medium"
          rel="noopener noreferrer"
          target="_blank"
        >
          Click here if you are not redirected
        </a>
      </div>
    </div>
  );
};

export default Checkout;
